import { CODE_BLOCK } from '@lumapps/wrex-code-block/constants';
import { EMBEDDED_MAP } from '@lumapps/wrex-embedded-map/constants';
import { EMBEDDED_VIDEO } from '@lumapps/wrex-embedded-video/constants';
import { ALIGNED_IMAGE_WRAPPER, IMAGE_GROUP } from '@lumapps/wrex-enhanced-image/constants';
import { FILE } from '@lumapps/wrex-file/constants';
import { IFRAME } from '@lumapps/wrex-iframe/constants';
import { LINK_PREVIEW } from '@lumapps/wrex-link-preview/constants';
import { LINK } from '@lumapps/wrex-link/constants';
import { LIST_ITEM, ORDERED_LIST, UNORDERED_LIST } from '@lumapps/wrex-list/constants';
import { PLAY_VIDEO } from '@lumapps/wrex-play-video/constants';
import { QUOTE_BLOCK } from '@lumapps/wrex-quote/constants';
import { T_D, T_R, TABLE } from '@lumapps/wrex-table/constants';
import {
    BOLD,
    COLORED,
    DIVIDER,
    HEADING,
    INLINE_CODE,
    ITALIC,
    PARAGRAPH,
    STRIKETHROUGH,
    UNDERLINE,
} from '@lumapps/wrex-typography/constants';
import { USER_MENTION } from '@lumapps/wrex-user-mention/constants';
import { WREX_CORE } from '@lumapps/wrex/keys';

export const STRUCTURED_CONTENT_WREX_EDITOR_CLASSNAME = 'wrex-editor';

export const DEFAULT_STRUCTURED_CONTENT_PLACEHOLDER = WREX_CORE.EDITOR_WITH_MENTION_PLACEHOLDER;

export const STRUCTURED_CONTENT_SERIALIZATION_ELEMENTS = [
    PARAGRAPH,
    HEADING,
    CODE_BLOCK,
    INLINE_CODE,
    DIVIDER,
    UNORDERED_LIST,
    ORDERED_LIST,
    LIST_ITEM,
    IMAGE_GROUP,
    ALIGNED_IMAGE_WRAPPER,
    USER_MENTION,
    LINK_PREVIEW,
    LINK,
    TABLE,
    T_R,
    T_D,
    QUOTE_BLOCK,
    IFRAME,
    EMBEDDED_MAP,
    EMBEDDED_VIDEO,
    PLAY_VIDEO,
    FILE,
] as const;

export const STRUCTURED_CONTENT_SERIALIZATION_MARKS = [BOLD, ITALIC, COLORED, STRIKETHROUGH, UNDERLINE] as const;
